import React, { PureComponent } from 'react'
import toggleListeners from 'local_modules/toggleListeners'


export default (options = { isToggleActive: false, toggleOnWindowClick: false }) =>

  (Component) => {

    class WrappedComponent extends PureComponent {

      node = null

      timeout = null

      state = {
        isToggleActive: options.isToggleActive,
        isCloseDisabled: false,
      }

      componentWillUnmount() {
        clearTimeout(this.timeout)
      }

      setCloseDisabled = () => {
        this.setState({
          isCloseDisabled: true,
        })

        this.timeout = setTimeout(() => {
          this.setState({
            isCloseDisabled: false,
          })
        }, 100)
      }

      toggleClose = (event = {}) => {
        const { isCloseDisabled } = this.state
        const { checkIsChild, removeListener } = this.props

        if (options.toggleOnWindowClick) {
          const isChild = checkIsChild(event.target, this.node)

          if (!isChild && !isCloseDisabled) {
            console.log('toggleClose')
            removeListener()
          }
          else {
            return
          }
        }

        this.setState({
          isToggleActive: false,
        })
      }

      toggleOpen = () => {
        const { isToggleActive } = this.state
        const { setListener } = this.props

        if (isToggleActive) {
          console.log('failed toggleOpen')
          return
        }

        console.log('toggleOpen')

        if (options.toggleOnWindowClick) {
          setListener(document, 'click', this.toggleClose)
        }

        this.setState({
          isToggleActive: true,
        })
      }

      render() {

        return (
          <Component
            setRef={(node) => this.node = node}
            {...this.props}
            {...this.state}
            toggleOpen={this.toggleOpen}
            toggleClose={this.toggleClose}
            setCloseDisabled={this.setCloseDisabled}
          />
        )
      }
    }

    return toggleListeners(WrappedComponent)
  }
